import { __awaiter } from "tslib";
import { JobService } from "@/servicesTs/models/general/job";
import { FailedJobService } from "@/servicesTs/models/general/failedJob";
const moduleJob = {
    namespaced: true,
    state: {
        loading: false,
        jobs: [],
        failed_jobs: [],
    },
    getters: {
        getLoading(state) {
            return state.loading;
        },
        getJob(state) {
            return state.jobs;
        },
        getFailedJob(state) {
            return state.failed_jobs;
        },
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setJob(state, data) {
            state.jobs = data;
        },
        setFailedJob(state, data) {
            state.failed_jobs = data;
        },
    },
    actions: {
        getJobsAndFailedJob({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const JOB = yield JobService.getAll();
                const FAILED_JOB = yield FailedJobService.getAll();
                commit("setJob", JOB);
                commit("setFailedJob", FAILED_JOB);
                commit("setLoading", false);
            });
        },
    },
};
export default moduleJob;
